<template>
    <section class="container">
        <div class="">
            <!-- <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                <adminSidenav></adminSidenav>
            </div> -->
            <div class="col">
                <div class="container">
                    <div>
                        <h2><i class="fa fa-bullhorn"></i> 공지사항</h2>
                    </div>
                    <table class="table">
                        <thead>
                       <tr>
                            <th class="text-center">제목</th>
                            <th class="text-center">등록일</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="noticeList.length == 0">
                            <th colspan="100%" class="text-center"> 공지사항이 등록되지 않았습니다.</th>
                        </tr>
                        <tr v-else v-for="(notice,idx) in noticeList">
                            <td><router-link :to="{name : 'noticeShow', params : { id : notice.id }}">{{notice.title}}</router-link></td>
                            <td class="text-center">{{notice.modifiedDate}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <button type="button" class="btn-white btn btn-block" v-on:click="nextPage()" v-if="currentLength === page.pageSize">더보기</button>
                </div>
                <div class="text-right">
                        <p v-if="$auth.check() && !!$auth.user().roleNames.includes('ADMIN')">
                            <button class="btn btn-primary" v-on:click="moveWrite()">글쓰기</button>
                        </p>
                    </div>
            </div>
        </div>
    </section>
</template>

<script>
    import adminSidenav from '@/components/admin/Sidenav.vue'
    const baseUrl = process.env.VUE_APP_NOTICE_API_URL || '/api/v1/notice';
    export default {
        name: 'NoticeList',
        components: { adminSidenav },
        data() {
            return {
                noticeList: [],
                page:{
                    pageNum:0,
                    pageSize:4
                },
                currentLength : 0
            }
        },
        methods: {
            nextPage() {
                    this.page.pageNum += 1;
                    this.getList();
            },
            getList() {
                let me = this;

                this.axios.get(`${baseUrl}/list?page=${this.page.pageNum}&size=${this.page.pageSize}`)
                    .then(function (res) {
                        me.currentLength = res.data.length;
                        if(me.page.pageNum === 0) {
                            me.noticeList = res.data;
                        } else {
                            for (let i = 0 ; i < res.data.length ; i++) {
                                me.noticeList.push(res.data[i]);
                            }
                        }
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            moveWrite() {
                this.$router.push("noticeWrite");
            }
        },
        mounted() {
            this.getList();
        },
    }
</script>
<style scoped>
    .container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 20px 15px;
    }
    
    /* 공지사항 전체 배경 */
    .row {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        margin: 0;
    }
    
    h2 {
        color: #2c3e50;
        margin-bottom: 20px;
        font-weight: 600;
        padding-bottom: 10px;
        border-bottom: 2px solid #2c3e50;
    }
    
    h2 i {
        color: #2c3e50;
        margin-right: 8px;
    }
    
    .table {
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        overflow: hidden;
        margin-bottom: 20px;
    }
    
    .table thead th {
        background-color: #2c3e50;
        color: white;
        font-weight: 600;
        padding: 15px;
        border: none;
    }
    
    .table tbody td {
        padding: 15px;
        border-bottom: 1px solid #f1f3f4;
        vertical-align: middle;
    }
    
    .table tbody tr:hover {
        background-color: rgba(44, 62, 80, 0.05);
    }
    
    .table tbody tr:last-child td {
        border-bottom: none;
    }
    
    .btn-primary {
        background-color: #2c3e50;
        border-color: #2c3e50;
        padding: 8px 20px;
        border-radius: 6px;
        font-weight: 500;
    }
    
    .btn-primary:hover {
        background-color: #1a252f;
        border-color: #1a252f;
    }
    
    .btn-white {
        background-color: white;
        border: 1px solid #dee2e6;
        color: #6c757d;
        padding: 12px;
        border-radius: 6px;
        margin-top: 20px;
        transition: all 0.3s ease;
    }
    
    .btn-white:hover {
        background-color: #f8f9fa;
        border-color: #adb5bd;
        color: #495057;
    }
    
    a {
        color: #2c3e50;
        text-decoration: none;
        transition: color 0.3s ease;
    }
    
    a:hover {
        color: #1a252f;
        text-decoration: none;
    }
    
    .text-center {
        color: #6c757d;
        font-style: italic;
    }
</style>